import React, { ComponentProps } from "react";
import "./ExtraTag.scss";

interface ExtraTagProps extends ComponentProps<"span"> {
  customClass?: string;
}

export function ExtraTag({ customClass, style }: ExtraTagProps) {
  return (
    <span
      className={`fw-bold text-capitalize d-inline-flex align-items-center justify-content-center Grotesk ExtraTag ${customClass}`}
      style={style}
    >
      Extra
    </span>
  );
}
